<div class="photo-viewer">
  <div class="photo-viewer__toolbar">
    <span class="photo-viewer__count">{{ activeIndex + 1 }} / {{ images.length }}</span>

    <div class="photo-viewer__controls">
      <button
        mat-icon-button
        type="button"
        [disabled]="!canZoomOut"
        matTooltip="Зменшити"
        aria-label="Зменшити фото"
        (click)="changeZoom(-0.5)"
      >
        <mat-icon>zoom_out</mat-icon>
      </button>
      <span class="photo-viewer__zoom">{{ zoom * 100 | number: '1.0-0' }}%</span>
      <button
        mat-icon-button
        type="button"
        [disabled]="!canZoomIn"
        matTooltip="Збільшити"
        aria-label="Збільшити фото"
        (click)="changeZoom(0.5)"
      >
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        [disabled]="!canResetView"
        matTooltip="Скинути масштаб"
        aria-label="Скинути масштаб"
        (click)="resetView()"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        class="photo-viewer__close"
        matTooltip="Закрити"
        aria-label="Закрити перегляд фото"
        (click)="close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div
    class="photo-viewer__stage"
    [class.photo-viewer__stage--zoomed]="isZoomed"
    (wheel)="onStageWheel($event)"
    (pointerdown)="onStagePointerDown($event)"
    (pointermove)="onStagePointerMove($event)"
    (pointerup)="onStagePointerEnd($event)"
    (pointercancel)="onStagePointerEnd($event)"
    (click)="onStageClick()"
  >
    <img
      *ngIf="activeImage"
      class="photo-viewer__image"
      [src]="activeImage"
      [alt]="title"
      [style.transform]="imageTransform"
      draggable="false"
      (error)="onImageError(activeIndex)"
    />
  </div>

  <button
    *ngIf="hasMultipleImages"
    mat-icon-button
    type="button"
    class="photo-viewer__nav photo-viewer__nav--prev"
    aria-label="Попереднє фото"
    (click)="showPrevious()"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>
  <button
    *ngIf="hasMultipleImages"
    mat-icon-button
    type="button"
    class="photo-viewer__nav photo-viewer__nav--next"
    aria-label="Наступне фото"
    (click)="showNext()"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>

  <div class="photo-viewer__strip" *ngIf="hasMultipleImages">
    <button
      type="button"
      class="photo-viewer__thumb"
      *ngFor="let image of images; let index = index"
      [class.photo-viewer__thumb--active]="index === activeIndex"
      [attr.aria-label]="'Фото ' + (index + 1)"
      (click)="selectImage(index)"
    >
      <img [src]="image" alt="" loading="lazy" (error)="onImageError(index)" />
    </button>
  </div>
</div>
